
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { DependantDetails } from '../../model/ngrx/dependant-details.model';

export const ADD_DEPENDANT_DETAILS = '[DEPDETAIL] Add';
export const REMOVE_DEPENDANT_DETAILS = '[DEPDETAIL] Remove';

// AddDependent Doctor's Details
export class AddDependantDetails implements Action {
    readonly type = ADD_DEPENDANT_DETAILS;

    constructor(public payload: DependantDetails) { }
}
// RemoveDependent Doctor's Details
export class RemoveDependantDetails implements Action {
    readonly type = REMOVE_DEPENDANT_DETAILS;

    constructor(public payload: number) { }
}

export type Actions = AddDependantDetails | RemoveDependantDetails;
